import React, {useState} from 'react';
import HistoryContext from "./HistoryContext";

export default function HistoryContextWrapper({children}) {
    const [loginReferer, setLoginReferer] = useState(null);

    const contextValue = {
        loginReferer,
        setLoginReferer,
    };

    return <HistoryContext.Provider value={contextValue}>
        {children}
    </HistoryContext.Provider>;
}
